// extracted by mini-css-extract-plugin
module.exports = {"confirmDisplay__inner":"confirmDisplay__inner","confirmDisplay__btnWrap":"confirmDisplay__btnWrap"};